import { render } from "./qna_write.vue?vue&type=template&id=54858120"
import script from "./qna_write.vue?vue&type=script&lang=js"
export * from "./qna_write.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__